import { render, staticRenderFns } from "./ThirdQuestion.vue?vue&type=template&id=470381c3&"
import script from "./ThirdQuestion.vue?vue&type=script&lang=js&"
export * from "./ThirdQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ThirdQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports